import cx from "classnames";
import type { FC, ReactNode } from "react";

import "./Heading.scss";

type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  children?: ReactNode;
  className?: string;
};

const Heading: FC<HeadingProps> = ({
  level = 1,
  size = "lg",
  children,
  className,
}) => {
  const appliedClasses = cx(className, "Heading", {
    "Heading--ExtraSmall": size === "xs",
    "Heading--Small": size === "sm",
    "Heading--Medium": size === "md",
    "Heading--Large": size === "lg",
    "Heading--ExtraLarge": size === "xl",
    "Heading--DoubleExtraLarge": size === "2xl",
  });
  const HeadingTag = `h${level}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  return <HeadingTag className={appliedClasses}>{children}</HeadingTag>;
};

export { Heading };
